/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { Edit } from '../../molecules'
import { TextInput } from '../../atoms'
import r from '../../../util/Renderer'
import SegmentationAction from '../../../action/segmentation'
import { CarefulButton, NormalButton } from 'ui-library/dist/external/components'

export default props => {
  const id = props.segment_category.id
  const category = props.segment_category
  const values = props.segment_values
  return (
    <Edit
      title={id ? `客層マスタの編集 [ID:${id}]` : `客層マスタの新規作成`}
      buttonLabel={id ? `更新` : '作成'}
      onSubmit={() => (id ? SegmentationAction.onRequestUpdate(category, values) : SegmentationAction.onRequestCreate(category, values))}
      onCancel={SegmentationAction.cancelCreateView}
    >
      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <p className="input-required">分類名</p>
            <TextInput name="name" value={category.name} onChange={SegmentationAction.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <div className="EditArea__column">
            <p className="input-required">表示順</p>
            <TextInput type="number" name="priority" min="1" max="100" value={category.priority} onChange={SegmentationAction.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--half">
          <div className="EditArea__column">
            <p className="input-required">表示/非表示</p>
            <p>
              <input id="category-status-1" type="radio" name="status" value="show" onChange={SegmentationAction.onEdit} checked={category.status === 'show'} />
              <label for="category-status-1">表示</label>
              &nbsp;&nbsp;
              <input id="category-status-2" type="radio" name="status" value="hide" onChange={SegmentationAction.onEdit} checked={category.status === 'hide'} />
              <label for="category-status-2">非表示</label>
            </p>
          </div>
        </div>
      </div>

      <h5>選択値</h5>

      {values &&
        values.map((value, index) => (
          <div key={`value-${index}`} className="EditArea__row">
            <div className="EditArea__row--half" style={{ height: '50px' }}>
              <div className="EditArea__column">
                <p className="input-required">
                  選択項目{index + 1} {r.renderIf(value.status === 'hide')(<span>(非表示)</span>)}
                </p>
                <TextInput name="name" value={value.name} onChange={e => SegmentationAction.onEditValue('name', e.target.value, index)} />
              </div>
            </div>
            <div className="EditArea__row--half" style={{ height: '50px' }}>
              <div className="EditArea__column">
                <p>表示順</p>
                <p>
                  <input
                    type="number"
                    name="priority"
                    min="1"
                    max="100"
                    value={value.priority}
                    onChange={e => SegmentationAction.onEditValue('priority', e.target.value, index)}
                    style={{ width: '3em', lineHeight: '15px', border: '0', outline: '0', borderBottom: '1px solid #A2A2A2' }}
                  />
                  <StatusButton index={index} value={value.status} />
                </p>
              </div>
            </div>
          </div>
        ))}
      <br />
      <NormalButton onClick={SegmentationAction.addRow}>項目を追加</NormalButton>
    </Edit>
  )
}

function StatusButton(props) {
  const { value, onChange, index } = props
  const style = { marginLeft: '16px', width: '72px', height: '24px' }
  return value === 'show' ? (
    <CarefulButton style={style} onClick={e => SegmentationAction.onEditValue('status', 'hide', index)}>
      非表示
    </CarefulButton>
  ) : (
    <NormalButton style={style} onClick={e => SegmentationAction.onEditValue('status', 'show', index)}>
      表示
    </NormalButton>
  )
}
